module.exports = __webpack_public_path__ + "static/media/downFilled-arraow.22daf61c.svg";